import { Outlet, Navigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";

export const AdminLayout = () => {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== "admin") {
    return (
      <div className="flex min-h-[60vh] items-center justify-center bg-flyers-black">
        <h1 className="font-heading text-2xl font-bold uppercase tracking-wide text-red-500">
          Access Denied - Admins Only
        </h1>
      </div>
    );
  }

  return (
    <div className="bg-flyers-black min-h-screen">
      <Outlet />
    </div>
  );
};
